<template>
  <div>
    <div style="background-color: white; padding: 10px; border-radius: 5px; position: relative;">
      <div class="el-descriptions__title" style="margin-bottom: 10px;">
        学员信息
        <el-button size="small" v-if="form.approveStatus != 1" type="primary" style="float: right; margin-top: 5px; margin-bottom: 10px;" @click="auditStu">
          审核
          <i class="el-icon-s-check el-icon--right"></i>
        </el-button>
      </div>
<!--      <el-upload
        style="display: inline-block; vertical-align: top;"
        class="avatar-uploader"
        accept=".jpg,.png"
        :action="url"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">

      </el-upload>-->
      <div style="display: inline-block; vertical-align: top;">
        <el-image
          style="width: 100px;"
          v-if="form.photo"
          :src="form.photo"
          fit="fit"></el-image>
        <i v-else class="el-icon-picture-outline-round avatar-uploader-icon"></i>
      </div>

      <el-descriptions style="display: inline-block; vertical-align: top; width: 80%; margin-left: 20px;">
        <el-descriptions-item label="学员名称">
          <el-link type="primary" @click="editDetail">
            {{ form.name }}
          </el-link>
          <el-tag type="success" size="mini" v-if="form.approveStatus == 1" class="tags">通过</el-tag>
          <el-tag type="warning" size="mini" v-if="form.approveStatus == 2" class="tags">未审核</el-tag>
          <el-tag type="danger" size="mini" v-if="form.approveStatus == 3" class="tags">不通过</el-tag>
        </el-descriptions-item>
<!--        <el-descriptions-item label="年龄">{{ form.age }} 岁</el-descriptions-item>-->
        <el-descriptions-item label="手机号码">{{ form.phone }}</el-descriptions-item>
        <el-descriptions-item label="身份证">{{ form.idcard }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ form.sex == 1 ? '男' : form.sex == 0 ? '女' : '' }}</el-descriptions-item>
        <el-descriptions-item label="工作单位">{{ form.company }}</el-descriptions-item>
        <el-descriptions-item label="地区">{{ form.areaName }}</el-descriptions-item>
        <el-descriptions-item label="学历">{{ form.edu }}</el-descriptions-item>
        <el-descriptions-item label="班级名称">{{ form.className }}</el-descriptions-item>
        <el-descriptions-item label="报名时间">{{ form.createTime }}</el-descriptions-item>
        <el-descriptions-item label="营销渠道">{{ form.marName }}</el-descriptions-item>
        <el-descriptions-item label="学习平台">{{ form.learnPlatformName }}</el-descriptions-item>
        <el-descriptions-item label="签名展示">
          <el-image
            style="width: 100px;"
            v-if="form.signUrl"
            :src="form.signUrl"
            :preview-src-list="[form.signUrl]"
            fit="fit"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="培训科目">{{ form.subjectName }}</el-descriptions-item>

      </el-descriptions>
    </div>

    <div style="background-color: white; padding: 10px; border-radius: 5px; position: relative; margin-top: 10px;">
      <el-tabs tab-position="left">
        <el-tab-pane label="报名资料">
          <el-button size="small" type="primary" style="margin-top: 5px; margin-bottom: 10px;" @click="editDetail">
            信息修改
            <i class="el-icon-edit-outline el-icon--right"></i>
          </el-button>
          <el-button size="small" type="primary" style="float: right; margin-top: 5px; margin-bottom: 10px;" @click="showUploadAll = true">
            上传
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <!-- 报名资料 列表数据 -->
          <el-table
            :data="fileList"
            border
            style="width: 100%">
            <el-table-column
              prop="attachUrl"
              label="图片"
              align="center">
              <template slot-scope="scope">
                <el-image
                  style="width: 60%"
                  v-if="scope.row.attachUrl && scope.row.attachType != '申请表' && scope.row.attachType != '学时证明'"
                  :src="scope.row.attachUrl"
                  :preview-src-list="[scope.row.attachUrl]"
                  fit="cover"></el-image>
                <el-image v-if="!scope.row.attachUrl && scope.row.attachType != '申请表' && scope.row.attachType != '学时证明'">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <el-link :href="scope.row.attachUrl" target="_blank">
                  <i v-if="scope.row.attachType == '申请表' || scope.row.attachType == '学时证明'" class="el-icon-tickets" style="font-size: 40px; cursor: pointer;"></i>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              prop="attachType"
              label="档案名"
              align="center">
            </el-table-column>
            <el-table-column
              label="操作"
              align="center">
              <template slot-scope="scope">
                <el-upload
                  style="display: inline-block; margin-right: 10px;"
                  ref="upload11"
                  class="upload-demo"
                  accept=".jpg,.png"
                  :action="url"
                  :on-success="
                  (response, file) => {
                      return uploadAttach(response, file, scope.row);
                    }
                  "
                  :before-upload="beforeAvatarUpload"
                  :limit="1">
                  <el-button size="small" type="primary">上传</el-button>
                </el-upload>
                <el-button
                  size="small"
                  type="danger"
                  v-if="scope.row.attachType != '身份证正面' && scope.row.attachType != '身份证反面'"
                  @click="deleteFile(scope.$index, scope.row)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

        </el-tab-pane>
<!--        <el-tab-pane label="历史证书" v-if="form.subjectName ? form.subjectName.slice(-2) != '初训' : false">
          <el-button size="small" type="primary" style="margin-top: 5px; margin-bottom: 10px;" @click="editDetail">
            信息修改
            <i class="el-icon-edit-outline el-icon&#45;&#45;right"></i>
          </el-button>
          <el-button size="small" type="primary" v-show="certList2.length == 0" style="float: right; margin-top: 5px; margin-bottom: 10px;" @click="openCert()">
            绑定
            <i class="el-icon-connection el-icon&#45;&#45;right"></i>
          </el-button>
          &lt;!&ndash; 历史证书 列表数据 &ndash;&gt;
          <el-table
            :data="certList2"
            border
            style="width: 100%">
            <el-table-column
              prop="certType1"
              label="证书类型"
              align="center">
            </el-table-column>
            <el-table-column
              prop="certType2"
              label="作业类别"
              align="center">
            </el-table-column>
            <el-table-column
              prop="certType3"
              label="操作项目"
              align="center">
            </el-table-column>
            <el-table-column
              prop="beginTime"
              label="有效期开始"
              align="center">
            </el-table-column>
            <el-table-column
              prop="endTime"
              label="有效期截止"
              align="center">
            </el-table-column>
            <el-table-column
              prop="toreviewTime"
              label="应复审时间"
              align="center">
            </el-table-column>
            <el-table-column
              prop="reviewTime"
              label="实际复审时间"
              align="center">
            </el-table-column>
            <el-table-column align="center" label="操作" >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="删除"
                  placement="top"
                >
                  <el-button
                    size="mini"
                    type="danger"
                    icon="el-icon-delete"
                    @click="deleteCert(scope.row)"
                  >
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>


        </el-tab-pane>-->
      </el-tabs>
    </div>

    <el-dialog title="上传学员文件" :visible.sync="showUploadAll" width="25%" top="5vh" :close-on-click-modal="false" @click="showUploadAll = false" append-to-body>
      <el-form label-width="120px" :model="fileEditForm" :rules="rules" ref="fileEditForm">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="附件类型" prop="attachId">
              <el-select size="small" v-model="fileEditForm.attachId" placeholder="请选择附件类型" style="width: 100%;">
                <el-option v-for="x in fileType" :label="x.name" :value="x.id" :key="x.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="附件文件" prop="attachUrl">
              <el-upload
                style="display: inline-block; margin-right: 10px;"
                ref="upload"
                class="upload-demo"
                accept=".jpg,.png"
                :action="url"
                :on-success="uploadFileAll"
                :before-upload="beforeAvatarUpload"
                :on-exceed="handleExceed"
                :limit="1">
                <el-button size="small" type="primary">上传文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showUploadAll = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitFileForm()">保存</el-button>
      </div>
    </el-dialog>


    <!-- 历史证书 对话框 -->
    <el-dialog :close-on-click-modal="false" title="历史证书列表" :visible.sync="certShow" width="60%" top="6vh"
               append-to-body>

      <el-table
        size="small"
        :data="certList"
        height="250"
        highlight-current-row
        v-loading="certLoading"
        border
        element-loading-text="拼命加载中"
        style="width: 100%;"
        @selection-change="certIdsChange"
        :row-key="(row) => { return row.id }"
      >
        <el-table-column type="selection" :selectable="selectable" width="55" align="center" :reserve-selection="true" />
        <el-table-column label="序号" align="center" type="index" width="60">
        </el-table-column>
        <el-table-column prop="certType1" label="证书类型" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="certType2" label="作业类别" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="certType3" label="操作项目">
        </el-table-column>
        <el-table-column prop="beginTime" label="有效期开始">
        </el-table-column>
        <el-table-column prop="endTime" label="有效期截止">
        </el-table-column>
        <el-table-column prop="toreviewTime" label="应复审时间">
        </el-table-column>
        <el-table-column prop="reviewTime" label="实际复审时间">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitCert">确 定</el-button>
        <el-button size="small" @click="certShow = false">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryStudentDetail,
  queryListByStuId,
  queryCert,          // 查询历史证书
  deleteCert,
  queryAllArea,

  queryCertificate,   // 根据复训科目id  查询历史证书
  saveCert,           // 保存历史证书

  queryAttach,
  saveFile,
  updateFile,
  deleteFile,
  approve
} from '../../../api/student'
import {
  selectAreaTree
} from '../../../api/subjectTree'
import {
  querySubjectDesc
} from "../../../api/subjectTree"
import { timestampToTime } from '../../../utils/util'
import Template from "../../../components/template";
import {reactive} from "vue";


export default {
  name: "studentDetail",
  components: {Template},
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      showAuditPopup: false,    // 打开 审核接口
      showUploadAll: false,   // 打开上传 全部的窗口
      loading: false, //是显示加载
      url: '/api/student/upload',
      openUpType: false,
      // 表单参数
      form: {
        photo: '',
      },

      fileList: [],
      certList2: [],

      fileEditForm: {},
      rules: {

      },

      fileType: [],

      pzItem: {},     // 科目配置信息

      // 历史证书
      certList: [],
      certShow: false,
      certLoading: false,
      certIds: [],
    }
  },
  created () {
    this.initDate();
  },
  methods: {
    timestampToTime,
    initDate() {
      if (this.item != undefined && JSON.stringify(this.item) != '{}') {
        this.queryStudentDetail()
        this.queryListByStuId()
        this.queryCert()
        this.queryAttach()
      } else {
        this.form = {
          photo: ''
        }
      }
    },
    // 查询 附件类型
    queryAttach() {
      queryAttach().then(res => {
        if (res.code == 200) {
          this.fileType = res.data;
        }
      })
    },

    selectable(row) {
      if (this.certIds.length > 0) {
        if (this.certIds[0].id == row.id) {
          return true
        } else {
          return false
        }
      } else {
        return true;
      }
    },
    // 查询详情数据
    queryStudentDetail() {
      queryStudentDetail(this.item).then(res => {
        if (res.code == 200) {
          this.form = res.data;
          this.querySubjectDesc();
          console.log('this.form', this.form);
        }
      })
    },
    // 查询科目配置
    querySubjectDesc() {
      querySubjectDesc({subjectId: this.form.subjectId}).then(res => {
        if (res.code == 200) {
          this.pzItem = res.data;
        }
      })
    },
    // 查询 附件数据
    queryListByStuId() {
      queryListByStuId({stuId: this.item.id}).then(res => {
        if (res.code == 200) {
          this.fileList = res.data;
        }
      })
    },
    // 查询 历史证书
    queryCert() {
      queryCert({studentId: this.item.id}).then(res => {
        if (res.code == 200) {
          if (res.data) {
            this.certList2.push(res.data);
          } else {
            this.certList2 = [];
          }
        }
      })
    },

    editDetail() {
      this.$emit('callBack')
    },

    // 删除绑定过的历史证书
    deleteCert(row) {
      this.$confirm('是否确定删除该历史证书?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCert({id: row.id}).then(res => {
          if (res.code == 200) {
            this.$message.success('删除成功！')
            this.queryCert();
          } else {
            this.$message.error(res.msg)
          }
        }).catch(err => {
          this.$message.error(err.response.data.msg);
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });


    },

    // 打开 绑定历史证书列表
    openCert() {
      this.certLoading = true;
      var params = {
        name: this.form.name,                           // this.form.name                   朱自风
        idcard: this.form.idcard,                       // this.form.idcard                 412326197209154511
        subjectId: this.form.subjectId                  // this.form.subjectId              196
      }

      queryCertificate(params).then(res => {
        this.certLoading = false;
        if (res.code == 200) {
          this.certList = res.data;
        }
      }).catch(err => {
        this.certLoading = false;
        this.$message.error(err.response.data.msg);
      })

      this.certShow = true;
    },
    // 选择历史证书
    certIdsChange(val) {
      this.certIds = JSON.parse(JSON.stringify(val))
    },
    // 保存选择的历史证书
    submitCert() {
      if (this.certIds.length === 0) {
        this.$message.error('请选择需要绑定的历史参数！');
        return;
      }
      var params = {};
      this.certIds.forEach(x => {
        params = {
          studentId: this.item.id,
          certType1: x.certType1,
          certType2: x.certType2,
          certType3: x.certType3,
          beginTime: x.beginTime,
          endTime: x.endTime,
          reviewTime: x.reviewTime,
          toreviewTime: x.toreviewTime
        }
      })

      // 判断是否满足条件
      if (this.form.subjectName.indexOf('特种作业人员') != -1) {
        // 特种作业人员，有实际复审时间(reviewTime不为nul)，取科目配置详情时间与 (end_time) 字段比较，没有实际复审时间 (reviewTime为取科目配置详情时间与(nul).toreviewTime)字段比较
        if (params.reviewTime) {

          // 从您的数据中获取复训时间、复训前天数和复训后天数（以毫秒为单位）
          const trainingDate = new Date(params.reviewTime); // 示例复训时间
          const daysBeforeTraining = this.pzItem.beforeDay; // 示例复训前天数
          const daysAfterTraining = this.pzItem.afterDay; // 示例复训后天数

          // 获取当前日期
          const currentDate = new Date();

          // 计算复训前后的时间范围（以毫秒为单位）
          const startDate = new Date(trainingDate.getTime() - daysBeforeTraining * 24 * 60 * 60 * 1000);
          const endDate = new Date(trainingDate.getTime() + daysAfterTraining * 24 * 60 * 60 * 1000);

          // 检查当前时间是否在报名时间范围内
          if (currentDate > startDate && currentDate < endDate) {
            console.log('您可以在复训前后时间内报名。');
          } else {
            this.$message.error('该证书不在报名时间范围内，无法报名！');
            return;
          }

        } else {

          // 从您的数据中获取复训时间、复训前天数和复训后天数（以毫秒为单位）
          const trainingDate = new Date(params.toreviewTime); // 示例复训时间
          const daysBeforeTraining = this.pzItem.beforeDay; // 示例复训前天数
          const daysAfterTraining = this.pzItem.afterDay; // 示例复训后天数

          // 获取当前日期
          const currentDate = new Date();

          // 计算复训前后的时间范围（以毫秒为单位）
          const startDate = new Date(trainingDate.getTime() - daysBeforeTraining * 24 * 60 * 60 * 1000);
          const endDate = new Date(trainingDate.getTime() + daysAfterTraining * 24 * 60 * 60 * 1000);

          // 检查当前时间是否在报名时间范围内
          if (currentDate > startDate && currentDate < endDate) {
            console.log('您可以在复训前后时间内报名。');
          } else {
            this.$message.error('该证书不在报名时间范围内，无法报名！');
            return;
          }

        }

      } else {
        // 安全生产管理人员、主要负责任人的，取科目配置详情时间与 (end_time) 字段比较

        // 从您的数据中获取复训时间、复训前天数和复训后天数（以毫秒为单位）
        const trainingDate = new Date(params.endTime); // 示例复训时间
        const daysBeforeTraining = this.pzItem.beforeDay; // 示例复训前天数
        const daysAfterTraining = this.pzItem.afterDay; // 示例复训后天数

        // 获取当前日期
        const currentDate = new Date();

        // 计算复训前后的时间范围（以毫秒为单位）
        const startDate = new Date(trainingDate.getTime() - daysBeforeTraining * 24 * 60 * 60 * 1000);
        const endDate = new Date(trainingDate.getTime() + daysAfterTraining * 24 * 60 * 60 * 1000);

        // 检查当前时间是否在报名时间范围内
        if (currentDate > startDate && currentDate < endDate) {
          console.log('您可以在复训前后时间内报名。');
        } else {
          this.$message.error('该证书不在报名时间范围内，无法报名！');
          return;
        }

      }

      saveCert(params).then(res => {
        if (res.code == 200) {
          this.certShow = false;
          this.$message.success('绑定成功！')
          this.queryCert()
        }
      }).catch(err => {
        this.$message.error(err.response.data.msg)
      })

    },

    // 审核 学员
    auditStu() {
      this.$confirm('是否通过审核?', '提醒', {
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        type: 'warning'
      })
      .then(() => {
        approve({studentIds: this.form.id, approveStatus: 1}).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功！');
            this.queryStudentDetail();
            this.$emit('sxTable');
          } else {
            this.$message.info(res.msg);
          }
        }).catch(err => {
          this.$message.error(err.response.data.msg);
        })
      })
      .catch(() => {
        approve({studentIds: this.form.id, approveStatus: 3}).then(res => {
          if (res.code == 200) {
            this.$message.success('审核成功！');
            this.queryStudentDetail();
            this.$emit('sxTable');
          } else {
            this.$message.info(res.msg);
          }
        }).catch(err => {
          this.$message.error(err.response.data.msg);
        })
      })
    },

    // 删除 图片
    deleteFile(index, item) {
      this.$confirm('确定要删除吗?', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var params = {
            id: item.id
          }
          deleteFile(params).then(res => {
            if (res.code == 200) {
              this.queryListByStuId()
              this.$message.success('删除成功！');
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.response.data.msg);
          })
        })
        .catch(() => {

      })
    },

    // 修改 附件信息
    uploadAttach(res, file, item) {
      var params = {
        attachUrl: res.data.url,
        id: item.id
      }
      updateFile(params).then(res => {
        if (res.code == 200) {
          this.queryListByStuId()
          this.$message.success('上传成功！');
          this.$refs.upload11.clearFiles();
          this.$refs.upload11.$el.querySelectorAll('.el-upload-list')[0].innerHTML = "" //去掉文件列表
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err.response.data.msg);
      })
    },

    // 上传 全部图片成功回调
    uploadFileAll(res, file) {
      this.fileEditForm.attachUrl = res.data.url;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`请先删除已上传的文件后，在进行新文件上传！`);
    },

    // 获取 文件服务器上图片的地址
    handleAvatarSuccess(res, file) {
      /* URL.createObjectURL(file.raw) */
      this.form.photo = res.data.url;
    },
    beforeAvatarUpload(file) {
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 保存 附件数据
    submitFileForm() {
      this.$refs['fileEditForm'].validate(valid => {
        if (valid) {
          this.fileEditForm.studenId = this.form.id;
          saveFile(this.fileEditForm).then(res => {
            this.showUploadAll = false;
            this.loading = false;
            if (res.code == 200) {
              this.queryListByStuId()
              this.$refs.upload.clearFiles();
              this.$message.success('保存成功');
            } else {
              this.$refs.upload.clearFiles();
              this.$message.info(res.msg);
            }
          }).catch(err => {
            this.loading = false
            this.$refs.upload.clearFiles();
            this.$message.error(err.response.data.msg)
          })
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    customCallback(type, item) {
      var data = {
        type: type, // 关闭 'refresh',// 执行父页面刷新
        item: item
      }
      this.$emit('sonHandleCallback', data)
    }

  }
}
</script>

<style scoped>
.tags {
  margin-left: 10px;
}
.form-add {
  padding: 0 20px 20px 20px;
  height: 100%;
  overflow: auto;
}
.form-add .form-add-body {
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 头像上传 */
/deep/ .avatar-uploader .el-upload {
  height: 105px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/student/studentDetail.vue